<template>
  <div>
    <div class="modal is-modal-xlarge" :class="{'is-active': active}">
      <div class="modal-background" @click.prevent.stop="close"></div>
      <div class="modal-card">
        <div class="row-width-actions-bar">
          <div class="columns is-gapless is-vcentered is-border-bottom">
            <div class="column is-padding-left">
              <div class="has-text-dark is-size-6 is-uppercase">
                <span class="has-text-weight-medium">{{params.title || 'Documents'}}</span>
              </div>
            </div>
            <div class="column is-narrow is-border-left">
              <a class="page-header-btn is-small is-square" @click="close">
                <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
              </a>
            </div>
          </div>
        </div>
        <section class="modal-card-body is-clipped">
          <div class="columns is-gapless is-clipped is-max-height-full" style="height: 500px; max-height: 80vh;"><!-- HB : style inline ajouter sinon chrome n'affiche pas la scroll bar-->
            <div class="column is-6 is-border-right is-overflow-auto" style="height: auto;"><!-- HB : style inline ajouter sinon chrome n'affiche pas la scroll bar-->
              <template v-for="(item, keyDocument, i) in selectedDocument">
                <div class="row-width-actions-bar columns is-gapless is-vcentered is-border-bottom" :key="'parent-'+i">
                  <div class="column is-padding-left">
                    <span class="has-text-dark is-size-6">{{item.label}}</span>
                  </div>
                  <div class="column is-narrow is-border-left">
                    <a class="page-header-btn is-small is-square" @click="toggleTable(keyDocument)">
                      <span class="icon is-size-4 has-text-dark">
                        <i class="fal" :class="open[keyDocument] ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                      </span>
                    </a>
                  </div>
                </div>
                <div @click="selectDocument(document)" class="vadRowSimple is-hoverable" v-show="open[keyDocument]" v-for="document in item.documents"
                     :key="'doc-' + Math.floor(Math.random(2) * 10000) + document.fus_id">
                  <span class="is-size-6">{{document.filename}}</span>
                  <a class="vadRowSimple-actions">
                    <span class="is-size-7 is-uppercase">Sélectionner</span>
                  </a>
                </div>
              </template>
            </div>
            <div class="column is-6 is-sticky-0 is-self-flex-start">
              <div class="notification is-warning is-marginless">
                <p class="is-uppercase is-size-7 has-text-bold">
                  <b>
                    Vous pouvez ajouter un fichier à partir de cette fenêtre.
                    <span class="is-padding-left-xsmall" v-helper.bottom="'48pvPnXWhfMnF10pIqZ4tj'">
                      <i class="fal fa-info-circle"></i>
                    </span>
                    <br>
                    Il sera enregistré dans le dossier "divers" de la rubrique document
                  </b>
                </p>
              </div>
              <upload-file @upload="uploadDocument"
                          :placeholder="'Sélectionner un fichier sur votre ordinateur OU faites glisser les fichiers dans cette zone'"
                          :documents="[]"
                          :is-image="true"
                          :show-list="false"
                          :is-square-input="true"
                          :icon="'fa-upload'"
                          class="is-border-bottom"
              ></upload-file>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DocumentsSelection',
    data () {
      return {
        open: {}
      }
    },
    props: {
      active: {
        type: Boolean,
        required: true
      },
      selectedDocument: {
        type: Object,
        required: true
      },
      params: {
        type: Object
      }
    },
    watch: {
      selectedDocument () {
        this.open = Object.keys(this.selectedDocument).map(x => {
          return {[x]: false}
        })
      }
    },
    methods: {
      close () {
        this.$emit('close')
      },
      toggleTable (v) {
        this.$set(this.open, [v], !this.open[v])
      },
      selectDocument (document) {
        this.$emit('submit', {document, from: this.params.from})
      },
      uploadDocument (document) {
        let newDoc = Array.isArray(document) ? document[0] : document
        this.$emit('submit', {document: newDoc, from: this.params.from})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modal/DocumentsSelection.vue